import { useState } from 'react';
import { ProductFeedbackModal } from './ProductFeedbackModal';

export function ProductFeedbackLauncher() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setIsOpen(true)}
        className="fixed right-4 bottom-4 z-[2500] flex items-center gap-xs rounded-medium border border-neutral-400 bg-neutral-700 px-sm py-xs text-sm font-semibold text-neutral-100 shadow-lg hover:bg-neutral-600 focus:outline-none focus:ring-2 focus:ring-red-500"
        aria-label="Send feedback"
        data-testid="product-feedback-launcher"
      >
        <i className="fas fa-comment-alt text-xs" aria-hidden="true" />
        Feedback
      </button>
      <ProductFeedbackModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
}
